import { type RefObject, useCallback } from 'react';

const mobilePaneScrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'nearest',
    inline: 'start',
};

export const useScrollIntoViewOnMobile = <TElement extends Element>(
    ref: RefObject<TElement | null>,
) => {
    return useCallback(() => {
        if (
            typeof window === 'undefined' ||
            !window.matchMedia('(max-width: 1023px)').matches
        ) {
            return;
        }
        ref.current?.scrollIntoView(mobilePaneScrollOptions);
    }, [ref]);
};
